// src/components/ModalConfirmacion.jsx
import React from "react";
import "../styles/ModalConfirmacion.css";

import { createPortal } from "react-dom";

export default function ModalConfirmacion(props) {
  if (!props.abierto) return null;

  return createPortal(
    <div className="modal-overlay">
      <div className="modal-contenido">
        <p>{props.mensaje}</p>

        <div className="modal-acciones">
          {props.textoSecundario && props.onSecundario && (
            <button onClick={props.onSecundario}>
              {props.textoSecundario}
            </button>
          )}

          <button onClick={props.onConfirmar}>
            {props.textoConfirmar || "Aceptar"}
          </button>

          <button class="boton-cancelar-modal" onClick={props.onCancelar}>
            Cancelar
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}


